/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, NgZone, Output} from '@angular/core';
import {NgForm} from '@angular/forms';
import * as _ from 'lodash';

import template from './order-quick-line-item-form.component.html';
import {Uuid} from '../../components/util/uuid';

@Component({
  standalone: false,
  selector: 'adn-order-quick-line-item-form',
  template
})
export class OrderQuickLineItemFormComponent {
  @Input() lineItem: any;
  @Input() isAxAdvertiser = false;
  @Input() objectiveFields: any = {};
  @Input() bidSpecificationFields: any = {};
  @Input() lineItemObjectivesAsStringFn: () => string = () => '';
  @Input() beforeSave: () => void = () => undefined;

  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  submitting = false;
  apiErrors: string[] = [];

  constructor(private readonly ngZone: NgZone) {
  }

  lineItemObjectivesAsString(): string {
    return this.lineItemObjectivesAsStringFn();
  }

  submitLineItem(form: NgForm): void {
    if (form.invalid || this.submitting) {
      return;
    }

    this.submitting = true;
    this.apiErrors = [];
    this.beforeSave();

    if (!this.lineItem.id) {
      this.lineItem.id = Uuid.generate();
    }

    const qStrings: any = {};
    if (_.get(this.lineItem, ['ignoreProduct'])) {
      qStrings.ignoreProduct = true;
    }

    this.lineItem.savePartial(null, 'save', _.isEmpty(qStrings) ? null : qStrings).then((savedItem: any) => {
      this.ngZone.run(() => {
        this.submitting = false;
        form.resetForm();
        this.saved.emit(savedItem);
      });
    }, (response: any) => {
      this.ngZone.run(() => {
        this.submitting = false;
        if ((response.status === 400 || response.status === 422) && response.data?.errors) {
          this.apiErrors = _.map(response.data.errors, (e: any) => e.text || e.code || 'Validation error');
        }
      });
    });
  }

  cancelForm(): void {
    this.cancelled.emit();
  }
}
